import Flex from '@eversports/react-components/primitives/Flex'
import Skeleton from '@eversports/react-components/primitives/Skeleton'

const SkeletonPatronQuestion = () => (
  <Flex flexDirection="column" verticalSpacing="default">
    <Skeleton variant="text" height="24px" width="182px" />
    <Flex flexDirection="column" verticalSpacing="dense">
      <Flex horizontalSpacing="default">
        <Skeleton variant="circular" width="25px" height="25px" />
        <Skeleton variant="text" height="20px" width="64px" />
      </Flex>
      <Flex horizontalSpacing="default">
        <Skeleton variant="circular" width="25px" height="25px" />
        <Skeleton variant="text" height="20px" width="64px" />
      </Flex>
    </Flex>
  </Flex>
)

export default SkeletonPatronQuestion
